import React, { useEffect, useState } from 'react';
import { Table } from 'reactstrap';
import { connect, useDispatch } from 'react-redux';

import { RootState } from '../../../../app/redux/rootReducer';

import { Link } from 'react-router-dom';
import { getUser } from '../../../../app/redux/appSelector';
import { User } from '../../../../models/user';
import { Workshop } from '../../../../models/workshop';
import { getWorkshopsBySection } from '../../../../services/api/workshopApi';
import { notificationActions } from '../../../../app/redux/notification.slice';
import { Loader } from '../../../../shared/components';
import Avatar from 'react-avatar';

interface Props {
  categoryId: string;
  sectionId: string;
  isWorkshopLoading: boolean;
  getUserDetails: (userId: string) => User | undefined;
}

const WorkshopList: React.FC<Props> = ({
  categoryId,
  sectionId,
  isWorkshopLoading,
  getUserDetails,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [workshopList, setWorkshopList] = useState<Array<Workshop>>([]);

  const dispatch = useDispatch();

  useEffect(() => {
    setIsLoading(true);
    getWorkshopsBySection(categoryId, sectionId).subscribe(
      (response: Array<Workshop>) => {
        setWorkshopList(response);
        setIsLoading(false);
      },
      (err: Error) => {
        setIsLoading(false);
        dispatch(
          notificationActions.setToast({
            severity: 'danger',
            message: err.message,
            title: `Error: Couldn't Fetch Workshops`,
          })
        );
      }
    );
  }, [categoryId, sectionId, dispatch, isWorkshopLoading]);

  const getUserAvatar = (userId: string) => {
    const user = getUserDetails(userId);
    return user ? (
      <Link to={'/users/'.concat(user.userId)}>
        <Avatar
          name={
            user.firstName &&
            user.lastName &&
            user.firstName.concat(' ').concat(user.lastName)
          }
          size="30"
          round="50%"
          color="#303f9f"
          fgColor="white"
        />
      </Link>
    ) : (
      ''
    );
  };

  return (
    <div className="table_outer_div">
      <div className="container">
        <div className="row align-items-start">
          <div className="col header-txt">
            <h5>Workshops</h5>
          </div>
        </div>
      </div>
      <Table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Responsible</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {isLoading || isWorkshopLoading ? (
            <Loader />
          ) : (
            <>
              {workshopList.map((item, index) => (
                <tr key={index}>
                  <td>{getUserAvatar(item.responsibleUserId)}</td>
                  <td>{item.workshopName}</td>
                  {/* <td className="view-td">
                    <Link
                      to={`/settings/workshop/${item.workshopId}`}
                      className="add-new-link-btn-thin-border ft-size-16"
                    >
                      <CgMoreVerticalR size={20} />
                    </Link>
                  </td> */}
                </tr>
              ))}
            </>
          )}
        </tbody>
      </Table>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  state,
  isWorkshopLoading: state.organization.workshopLoading,
  getUserDetails: (userId: string) => getUser(state, userId),
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(WorkshopList);
